import axios from "axios";

const AxiosRecibir = async ({ endpoint }) => {
    try {
        const token = localStorage.getItem("token");
        const baseURL = process.env.REACT_APP_API_URL;
        const fullURL = `${baseURL}${endpoint}`;

        const response = await axios.get(fullURL, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
                Expires: "0",
            },
            params: { _: Date.now() },
        });
        //return response.data;
        return response;

    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

export default AxiosRecibir;
